import { BaseController } from '../../../../../../../common/base/controller';
import {
  MODEL_FIELDS,
  ACCOUNTSWITCH_INITIAL_WEEKS_SHIFT,
} from '../../createRequest.model';
import _ from 'lodash';
import moment from 'moment';
import { toUtcMidnight } from '../../../../../../../common/helper/date';

export class AccountswitchDatesController extends BaseController {
  constructor($scope, controllerService, ticketsService, pdfViewerService) {
    'ngInject';
    super({
      $scope,
      controllerService,
      ticketsService,
      pdfViewerService,
    });
  }

  inputMessagesFor(field) {
    return {
      parse: 'receiving.createRequest.form.error.dateInvalid',
      required: `receiving.createRequest.form.error.required.${field}`,
      min: 'receiving.createRequest.form.error.minDate',
    };
  }

  get accountCloseSectionAtBeginningOfWarrantForm() {
    return this.isFeatureActive(
      this.FeatureNames.FF_ACCOUNT_CLOSE_SECTION_AT_BEGINNING_OF_WARRANT_FORM,
    );
  }

  setupFormMessages() {
    this.acceptDebitspecialDateMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.acceptDebitspecialDate,
    );
    this.accountswitchSpecificDateMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.accountswitchSpecificDate,
    );

    this.refuseStandingOrdersDeadlineMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.refuseStandingOrdersDeadline,
    );

    this.accountCloseDeadlineMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.accountCloseDeadline,
    );

    this.acceptDebitDateForPaymentpartnersMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.acceptDebitDateForPaymentpartners,
    );

    this.acceptDepositsDateForPaymentpartnersMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.acceptDepositsDateForPaymentpartners,
    );

    this.refuseDebitsAndDepositsPartnerDeadlineMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.refuseDebitsAndDepositsPartnerDeadline,
    );

    this.transferBalanceDeadlineMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.transferBalanceDeadline,
    );

    this.accountCloseDeadlineMessages = this.inputMessagesFor(
      this.MODEL_FIELDS.closeAccountDeadline,
    );
  }

  downloadPreviewOfAccountswitchDatesProtocol() {
    const depositsDate =
      this.model[this.MODEL_FIELDS.acceptDepositsDateForPaymentpartners];
    const debitsDate =
      this.model[this.MODEL_FIELDS.acceptDebitDateForPaymentpartners];

    this.downloadingPreviewOfAccountswitchDatesProtocol = true;
    this.ticketsService
      .downloadPreviewOfAccountswitchDatesProtocol({
        depositsDate: new Date(depositsDate),
        debitsDate: new Date(debitsDate),
      })
      .then((base64String) => {
        this.downloadingPreviewOfAccountswitchDatesProtocol = false;
        const url = this.pdfViewerService.makeBase64Downloadable(base64String);
        this.pdfViewerService.downloadIt(
          url,
          'ErmächtigungWechselDatumProtokoll.pdf',
        );
      });
  }

  get canDownloadProtocol() {
    if (!this.form) return false;

    const acceptDebitDateForPaymentpartners =
      this.form[
        `${this.MODEL_FIELDS.acceptDebitDateForPaymentpartners}.simpleForm`
      ];
    const acceptDepositsDateForPaymentpartners =
      this.form[
        `${this.MODEL_FIELDS.acceptDepositsDateForPaymentpartners}.simpleForm`
      ];

    if (
      !acceptDebitDateForPaymentpartners ||
      !acceptDepositsDateForPaymentpartners
    )
      return false;

    return (
      acceptDepositsDateForPaymentpartners.$valid &&
      acceptDebitDateForPaymentpartners.$valid
    );
  }

  setupDates() {
    this.model[this.MODEL_FIELDS.closeAccount] = true;

    _.forEach(ACCOUNTSWITCH_INITIAL_WEEKS_SHIFT, (weeks, field) => {
      const value = this.model[field] || moment().add(weeks, 'weeks').toDate();

      this.model[field] = toUtcMidnight(value);
    });

    this.dateOptions = {
      dateFormat: this.languageOptions.dateFormat,
      // accountswitch can not happen in the past
      minDate: new Date(),
    };
  }

  getLabelFor(field) {
    return `receiving.createRequest.warrantForm.${field}`;
  }

  $onInit() {
    this.MODEL_FIELDS = MODEL_FIELDS;
    this.setupFormMessages();
    this.setupDates();
  }
}
